import { cn } from '@/lib/utils'

// All four brand accent colors flowing warm → cool, then looping back
const BRAND_GRADIENT = 'linear-gradient(90deg, #FF9D76, #FFE176, #C176FF, #76F1FF, #FF9D76)'

interface BrandLoadingBarProps {
  /** 0–100 for determinate mode; omit for the animated indeterminate sweep */
  value?: number
  height?: 'sm' | 'md' | 'lg'
  className?: string
}

const heightMap: Record<NonNullable<BrandLoadingBarProps['height']>, string> = {
  sm: 'h-1',
  md: 'h-2',
  lg: 'h-3',
}

export function BrandLoadingBar({ value, height = 'md', className }: BrandLoadingBarProps) {
  const isIndeterminate = value === undefined

  return (
    <div
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={isIndeterminate ? undefined : value}
      className={cn('relative w-full overflow-hidden rounded-full bg-muted', heightMap[height], className)}
    >
      {isIndeterminate ? (
        // 200%-wide div holds 2 gradient tiles (each 50% of the div = 100% of the bar).
        // Sliding left by 50% of the div moves exactly one full tile, so the loop is seamless.
        <div
          className="absolute inset-y-0 left-0 h-full w-[200%] animate-brand-loading-sweep"
          style={{ background: BRAND_GRADIENT, backgroundSize: '50% 100%', backgroundRepeat: 'repeat' }}
        />
      ) : (
        <div
          className="absolute inset-y-0 left-0 rounded-full transition-all duration-300 ease-out"
          style={{
            width: `${Math.min(100, Math.max(0, value))}%`,
            background: BRAND_GRADIENT,
          }}
        />
      )}
    </div>
  )
}
